import { Link } from "react-router-dom";
import { CalenderIcon, ReadMoreIcon } from "../Header/Icon";
import { motion } from "framer-motion";
import { ReadMore } from "../../Buttons/Buttons";

export default function Card({ activity, t, i18n }) {
  return (
    <motion.div
    dir={i18n.language === "ar" || i18n.language === "ckb" ? "rtl" : "ltr"}
      whileTap={{ scale: 0.98 }}
      
      className="bg-white   w-11/12 h-[370px] rounded-md shadow-md transition-transform duration-500 flex flex-col"
    >
      {/* Image container */}
      <div className="relative w-full  overflow-hidden rounded-t-md">
        <div className="relative w-full overflow-hidden" >
          <motion.img
          style={{ aspectRatio: '16/9' }}
            src={process.env.REACT_APP_IMG_URL + activity.image}
            alt="Activity"
            className="w-full h-full object-cover"
            whileHover={{
              scale: 1.05,
              transition: { duration: 0.4 }
            }}
            initial={{ scale: 1 }}
            transition={{ duration: 0.3 }}
          />
        </div>

        {/* Gradient overlay */}
        {/* <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div> */}

        {/* Date badge */}
        <div className="absolute top-4 right-4 bg-green-700 px-3 py-1.5 rounded-lg shadow text-gray-100 flex items-center gap-2 text-sm">
          <CalenderIcon className="w-4 h-4 text-white" />
          <span>
            {new Date(activity.published_at).toLocaleDateString("en-US", {
              month: "short",
              day: "numeric",
              year: "numeric",
            })}
          </span>
        </div>
      </div>

      {/* Content Section */}
      <div className="flex flex-col justify-between flex-1 pt-4 2xl:pt-3 px-4 pb-4">
        <div>
          <Link to={`/activity/${activity.id}`} className="block">
            <h2 className="text-xl font-bold text-gray-900 leading-tight">
              <span className="bg-gradient-to-r from-emerald-400/30 to-cyan-400/30 bg-[length:0%_3px] bg-left-bottom bg-no-repeat transition-[background-size] duration-300 hover:bg-[length:100%_3px]">
                {activity.title}
              </span>
            </h2>
          </Link>

          <p
            className="text-gray-600 text-sm "
            dangerouslySetInnerHTML={{
              __html:
                activity.description.length > 70
                  ? activity.description.substring(0, 70)  + "..."
                  : activity.description,
            }}
          />
        </div>

        <ReadMore link={`/activity/${activity.id}`} />

      </div>
    </motion.div>
  );
}
